import React from "react";
import { Row, Col, Container, Button } from "reactstrap";

const GetStartedNow = () => {
    return (
        <div className="ready-bg">
            <Container>
                <div className="content-areyouready">
                    <Row className="text-right justify-content-center">
                        <Col md="4">
                            <h3 className="text-ready mt-1">Get Started Now.</h3>
                        </Col>
                        <Col md="2">
                            <Button className="btn button-ready" onClick={() => (window.open(process.env.REACT_APP_CONTACTUS,'_blank'))}>Contact Us</Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}

export default GetStartedNow;
